import React from 'react';
import {useRouter} from 'next/router'

import CenteredItem from '../common/CenteredItem';
import EmailInput from '../forms/EmailInput';
import {callApi} from '../../helpers/Api';

const ForgotUsername = (props) => {
    const router = useRouter();

    return (
        <CenteredItem
            header={'Forgot Your Username?'}
            description={'No problem! We will send your username to your email!'}
            item={
                <EmailInput
                    className="medium-darkable"
                    buttonText='send forgot username email'
                    handleSubmit={(email) => {
                        callApi('/auth/forgot/username', {
                            method: 'POST',
                            body: JSON.stringify({
                                email,
                            }),
                        })
                        .then(res => {
                            if(res.success)
                                router.replace('/email/sent/forgot-username/' + email);
                        })
                    }}
                />
            }
        />
    );
}

export default ForgotUsername
